import { render, staticRenderFns } from "./tableClientGroups.vue?vue&type=template&id=238a5004&scoped=true"
import script from "./tableClientGroups.vue?vue&type=script&lang=js"
export * from "./tableClientGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a5004",
  null
  
)

export default component.exports